import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class DashboardTiles extends Component {

  standardRow = (dashboardTile) => {
    // console.log('DashboardTiles.js/standardRow (dashboardTile)', dashboardTile);
    return (
      <Row className="adminRow pointer dashboardTileRow" onClick={() => this.props.onEdit(dashboardTile.DashboardTileId)}>
        <Col md={5} className="text-left">
          <FontAwesomeIcon icon={(dashboardTile['Active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((dashboardTile['Active']) ? 'iconActive' : 'iconInactive')} />
          {dashboardTile['Name']}
        </Col>
        <Col md={6} className="text-left">{dashboardTile['Description']}</Col>
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Dashboard Tiles">
          <Col md={1} className="text-right" onMouseDown={() => this.props.setDragTarget(null)}>
            <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
          </Col>
        </PermissionWrapper>
      </Row>
    )
  }

  editRow = (dashboardTile) => {
    // console.log('DashboardTiles.js/editRow (dashboardTile)', dashboardTile);
    return (<>
      <Row key={"edit" + dashboardTile.DashboardTileId} className="adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Name"
                type="text"
                id={"edit-name" + dashboardTile.DashboardTileId}
                name="name"
                value={this.props.editDashboardTile.name || ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id={"edit-description" + dashboardTile.DashboardTileId}
                name="description"
                value={this.props.editDashboardTile.description || ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Tags"
                type="text"
                id={"edit-types" + dashboardTile.DashboardTileId}
                name="types"
                value={this.props.editDashboardTile.types || ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Module"
                type="text"
                id={"edit-module" + dashboardTile.DashboardTileId}
                name="module"
                value={this.props.editDashboardTile.module || ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"edit-active" + dashboardTile.DashboardTileId}
                name="active"
                checked={this.props.editDashboardTile.active || false}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + dashboardTile.DashboardTileId}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Dashboard Tiles">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Dashboard Tile">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Dashboard Tiles">
            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(dashboardTile.DashboardTileId)} title="Delete Dashboard Tiles">
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={12} className="text-left py-3 px-0">
          <FormGroup className="px-2">
            <Input
              placeholder="Configuration"
              type="textarea"
              id={"edit-configuration" + dashboardTile.DashboardTileId}
              name="configuration"
              value={this.props.editDashboardTile.configuration || ''}
              onChange={e => this.props.onChange(e, 'edit')} />
          </FormGroup>
        </Col>
      </Row>
    </>
    )
  }

  addRow = () => {
    // console.log('DashboardTiles.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Workflow
            </FormGroup> */}
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="New Dashboard Tile Name"
                type="text"
                id="dashboardTile-add-name"
                name="name"
                value={this.props.newDashboardTile.name || ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id="dashboardTile-add-description"
                name="description"
                value={this.props.newDashboardTile.description || ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Tags"
                type="text"
                id="dashboardTile-add-types"
                name="types"
                value={this.props.newDashboardTile.types || ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Module"
                type="text"
                id="dashboardTile-add-module"
                name="module"
                value={this.props.newDashboardTile.module || ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"dashboardTile-add-active"}
                name="active"
                checked={this.props.newDashboardTile.active || false}
                onChange={e => this.props.onChange(e)} />
              <Label for={"dashboardTile-add-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newDashboardTile.name === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Dashboard Tile</Button>
        </Col>
        <Col md={12} className="text-left py-3">
          <Form >
            <FormGroup className="">
              <Input
                placeholder="Configuration"
                type="textarea"
                id="dashboardTile-add-configuration"
                name="configuration"
                value={this.props.newDashboardTile.configuration || ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
          </Form>
        </Col>
      </Row>
    )
  }

  render() {
    // console.log('DashboardTiles.js/render', this.props.editDashboardTile);
    return (
      <Container className="adminContainer" fluid>
        <ReactDragListView {...this.props.dragProps}>
          {this.props.dashboardTiles.map(dashboardTile => (
            <Fragment key={dashboardTile.DashboardTileId}>{this.props.editDashboardTile.dashboardTileId === dashboardTile.DashboardTileId ? this.editRow(dashboardTile) : this.standardRow(dashboardTile)}</Fragment>
          ))}
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Dashboard Tiles">
            {this.addRow()}
          </PermissionWrapper>
        </ReactDragListView>
      </Container>
    );

  }
}

export default DashboardTiles;
